var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label-width":_vm.itemRender.width,"label":_vm.itemRender.label,"required":_vm.itemRender.required ? true : false}},[_c('div',{staticClass:"enclosure"},[_c('i',{staticClass:"el-icon-picture-outline"}),_c('span',[_vm._v("添加图片")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }